(function () {
  const COD_API = '/apps/cod/create';
  const PHONE_ERROR =
    'رقم هاتف تونسي غير صحيح. استعمل 8 أرقام (مثال: 22 222 222).';

  const FIELD_MESSAGES = {
    name: 'أدخل اسمك.',
    phone: PHONE_ERROR,
    ville: 'اختر ولايتك.',
    address: 'أدخل عنوانك (5 أحرف على الأقل).',
    email: 'أدخل بريدًا إلكترونيًا صحيحًا.',
  };

  const QTY_SELECTOR = '[data-input-quantity], input[name="quantity"]';

  function formatPhoneInput(raw) {
    let digits = String(raw || '').replace(/\D/g, '');
    if (digits.startsWith('00216')) digits = digits.slice(5);
    else if (digits.startsWith('216')) digits = digits.slice(3);
    else if (digits.startsWith('0') && digits.length > 8) digits = digits.slice(1);
    digits = digits.slice(0, 8);
    if (digits.length <= 2) return digits;
    if (digits.length <= 5) return `${digits.slice(0, 2)} ${digits.slice(2)}`;
    return `${digits.slice(0, 2)} ${digits.slice(2, 5)} ${digits.slice(5)}`;
  }

  function formatMoney(cents) {
    const amount = (Number(cents) || 0) / 100;
    const text = Number.isInteger(amount) ? String(amount) : amount.toFixed(3);
    return `${text} DT · د.ت`;
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, (c) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;',
    })[c]);
  }

  function normalizeTunisiaPhone(raw) {
    let digits = String(raw || '').replace(/\D/g, '');
    if (digits.startsWith('00216')) digits = digits.slice(5);
    else if (digits.startsWith('216')) digits = digits.slice(3);
    else if (digits.startsWith('0') && digits.length === 9) digits = digits.slice(1);
    if (digits.length !== 8 || !/^[234579]\d{7}$/.test(digits)) return null;
    return digits;
  }

  function formatTunisiaPhone(digits) {
    return `${digits.slice(0, 2)} ${digits.slice(2, 5)} ${digits.slice(5)}`;
  }

  function splitName(fullName) {
    const parts = String(fullName || '')
      .trim()
      .split(/\s+/)
      .filter(Boolean);
    if (!parts.length) return { prenom: '', nom: '' };
    if (parts.length === 1) return { prenom: parts[0], nom: parts[0] };
    return { prenom: parts[0], nom: parts.slice(1).join(' ') };
  }

  function getRoot(el) {
    return el.closest('[data-product-cod-checkout]');
  }

  function getForm(root) {
    return root?.querySelector('[data-quick-order-form]');
  }

  // The quantity block and the variant pickers live outside the COD block,
  // in the same product info column.
  function getScope(root) {
    return root.closest('.featured-product-content') || root.closest('section') || document;
  }

  function readFields(form) {
    const name = form.querySelector('[data-quick-order-field="name"]')?.value.trim() || '';
    const { prenom, nom } = splitName(name);
    return {
      name,
      prenom,
      nom,
      phone: form.querySelector('[data-quick-order-field="phone"]')?.value.trim() || '',
      email: form.querySelector('[data-quick-order-field="email"]')?.value.trim() || '',
      address: form.querySelector('[data-quick-order-field="address"]')?.value.trim() || '',
      ville: form.querySelector('[data-quick-order-field="ville"]')?.value.trim() || '',
    };
  }

  function showGlobalError(form, message) {
    const el = form.querySelector('[data-quick-order-error]');
    if (!el) return;
    el.textContent = message || '';
    el.hidden = !message;
  }

  function setFieldError(form, fieldKey, message) {
    const wrap = form.querySelector(`[data-cod-field="${fieldKey}"]`);
    const errEl = form.querySelector(`[data-field-error="${fieldKey}"]`);
    const input = form.querySelector(`[data-quick-order-field="${fieldKey}"]`);

    if (errEl) {
      errEl.textContent = message || '';
      errEl.hidden = !message;
    }
    if (wrap) wrap.classList.toggle('product-cod-form__field--error', Boolean(message));
    if (input) input.setAttribute('aria-invalid', message ? 'true' : 'false');
  }

  function validateField(fieldKey, fields) {
    switch (fieldKey) {
      case 'name':
        if (!fields.name || fields.name.length < 2) return FIELD_MESSAGES.name;
        return null;
      case 'phone':
        if (!normalizeTunisiaPhone(fields.phone)) return FIELD_MESSAGES.phone;
        return null;
      case 'ville':
        if (!fields.ville) return FIELD_MESSAGES.ville;
        return null;
      case 'address':
        if (!fields.address || fields.address.length < 5) return FIELD_MESSAGES.address;
        return null;
      case 'email':
        if (fields.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(fields.email)) {
          return FIELD_MESSAGES.email;
        }
        return null;
      default:
        return null;
    }
  }

  function validateAll(form) {
    const fields = readFields(form);
    let firstErrorKey = null;

    ['name', 'phone', 'ville', 'address', 'email'].forEach((key) => {
      const message = validateField(key, fields);
      setFieldError(form, key, message);
      if (message && !firstErrorKey) firstErrorKey = key;
    });

    if (firstErrorKey) {
      showGlobalError(form, 'يرجى تصحيح الحقول المحددة باللون الأحمر أعلاه.');
      const wrap = form.querySelector(`[data-cod-field="${firstErrorKey}"]`);
      wrap?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      return false;
    }

    showGlobalError(form, '');
    return true;
  }

  function getQuantityInput(root) {
    return root.querySelector(QTY_SELECTOR) || getScope(root).querySelector(QTY_SELECTOR);
  }

  function getQuantity(root) {
    return Math.max(1, parseInt(getQuantityInput(root)?.value, 10) || 1);
  }

  function setQuantity(root, value) {
    const input = getQuantityInput(root);
    if (!input) return;
    input.value = String(value);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function getVariantId(root) {
    return root.querySelector('input[name="id"]')?.value;
  }

  function getVariants(root) {
    if (root._codVariants) return root._codVariants;
    let list = [];
    try {
      list = JSON.parse(root.querySelector('[data-cod-variants]')?.textContent || '[]');
    } catch (e) {
      console.warn('product-cod variants', e);
    }
    root._codVariants = new Map(list.map((v) => [String(v.id), v]));
    return root._codVariants;
  }

  // Items the customer added with "add another colour", in order.
  function getSavedLines(root) {
    if (!root._codLines) root._codLines = [];
    return root._codLines;
  }

  // What will be ordered: the saved items, plus the current selection
  // unless that exact variant is already saved.
  function getOrderLines(root) {
    const variants = getVariants(root);
    const toLine = (id, qty, savedIndex) => {
      const variant = variants.get(String(id));
      return {
        id: String(id),
        qty,
        savedIndex,
        title: variant?.title || '',
        price: Number(variant ? variant.price : root.dataset.variantPrice) || 0,
      };
    };

    const lines = getSavedLines(root).map((line, index) => toLine(line.id, line.qty, index));
    const currentId = getVariantId(root);
    if (currentId && !lines.some((line) => line.id === String(currentId))) {
      lines.push(toLine(currentId, getQuantity(root), -1));
    }
    return lines;
  }

  function shippingFee(root, subtotal) {
    const fee = Number(root.dataset.shippingFee) || 800;
    const min = Number(root.dataset.freeShippingMin) || 20000;
    return subtotal >= min ? 0 : fee;
  }

  // Pack prices come from the product metafields custom.pack_2_price / custom.pack_3_price
  // (in cents). A tier is only used when it is cheaper than buying the pieces one by one.
  function getPackTiers(root, unitPrice) {
    return [
      { qty: 3, total: Number(root.getAttribute('data-pack-3')) || 0 },
      { qty: 2, total: Number(root.getAttribute('data-pack-2')) || 0 },
    ].filter((tier) => tier.total > 0 && tier.total < tier.qty * unitPrice);
  }

  // Total for the whole order with packs applied: as many 3-packs as possible,
  // then 2-packs, then single pieces at their own price.
  function packPricing(root, lines) {
    const pieces = lines.reduce((sum, line) => sum + line.qty, 0);
    const subtotal = lines.reduce((sum, line) => sum + line.price * line.qty, 0);
    const unitPrice = pieces ? Math.max(...lines.map((line) => line.price)) : 0;

    let left = pieces;
    let packed = 0;
    getPackTiers(root, unitPrice).forEach((tier) => {
      const count = Math.floor(left / tier.qty);
      packed += count * tier.total;
      left -= count * tier.qty;
    });
    const total = Math.min(subtotal, packed + left * unitPrice);
    return { pieces, subtotal, total, discount: subtotal - total };
  }

  // Spreads the pack total over the lines so the order lines add up to it.
  function discountedLines(lines, pricing) {
    if (!pricing.discount) return lines;
    const unit = Math.floor(pricing.total / pricing.pieces);
    let rest = pricing.total - unit * pricing.pieces;
    return lines.map((line) => {
      let price = unit;
      if (rest > 0 && line.qty === 1) {
        price += rest;
        rest = 0;
      }
      return { ...line, price };
    });
  }

  function renderLines(root, lines) {
    const list = root.querySelector('[data-cod-lines]');
    if (!list) return;

    const hasSaved = getSavedLines(root).length > 0;
    list.hidden = !hasSaved;
    if (!hasSaved) {
      list.innerHTML = '';
      return;
    }

    list.innerHTML = lines
      .map((line) => {
        const action =
          line.savedIndex >= 0
            ? `<button type="button" class="product-cod-lines__remove" data-cod-remove-line="${line.savedIndex}" aria-label="حذف">×</button>`
            : `<span class="product-cod-lines__current">${escapeHtml(root.dataset.currentLabel || '')}</span>`;
        return (
          '<li class="product-cod-lines__item">' +
          `<span class="product-cod-lines__title">${escapeHtml(line.title)} × ${line.qty}</span>` +
          `<strong dir="ltr">${formatMoney(line.price * line.qty)}</strong>` +
          action +
          '</li>'
        );
      })
      .join('');
  }

  // Highlights the offer card that matches the number of pieces in the order
  // (3 and more stay on the 3-piece card).
  function renderPackOptions(root, pricing) {
    const options = root.querySelectorAll('[data-cod-pack-option]');
    const sizes = Array.from(options, (option) => Number(option.dataset.codPackOption));
    const active = Math.max(...sizes.filter((size) => size <= pricing.pieces), 1);
    options.forEach((option) => {
      const on = Number(option.dataset.codPackOption) === active;
      option.classList.toggle('is-active', on);
      option.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  // Pack mode (products with pack prices): colour and size are picked per piece
  // under the offer cards, and the theme's own pickers and quantity are hidden.
  function isPackMode(root) {
    return root.hasAttribute('data-cod-pack-mode');
  }

  function getOptions(root) {
    if (root._codOptions) return root._codOptions;
    try {
      root._codOptions = JSON.parse(root.querySelector('[data-cod-options]')?.textContent || '[]');
    } catch (e) {
      console.warn('product-cod options', e);
      root._codOptions = [];
    }
    return root._codOptions;
  }

  function findVariant(root, values) {
    for (const variant of getVariants(root).values()) {
      if ((variant.options || []).every((value, i) => value === values[i])) return variant;
    }
    return null;
  }

  function currentOptions(root) {
    const variant = getVariants(root).get(String(getVariantId(root)));
    return variant ? variant.options.slice() : getOptions(root).map((option) => option.values[0]);
  }

  // One entry per piece: the chosen option values, e.g. ["Noir", "38"].
  function getPieces(root) {
    if (!root._codPieces) root._codPieces = [currentOptions(root)];
    return root._codPieces;
  }

  // New pieces start as a copy of the last one, so "3 pieces" in one colour is a single click.
  function setPieceCount(root, count) {
    const pieces = getPieces(root);
    while (pieces.length < count) pieces.push(pieces[pieces.length - 1].slice());
    pieces.length = Math.max(1, count);
  }

  function pieceLines(root) {
    const lines = [];
    getPieces(root).forEach((values) => {
      const variant = findVariant(root, values);
      if (!variant) return;
      const line = lines.find((item) => item.id === String(variant.id));
      if (line) line.qty += 1;
      else {
        lines.push({
          id: String(variant.id),
          qty: 1,
          savedIndex: -1,
          title: variant.title,
          price: Number(variant.price) || 0,
        });
      }
    });
    return lines;
  }

  function invalidPieces(root) {
    return getPieces(root).some((values) => {
      const variant = findVariant(root, values);
      return !variant || variant.available === false;
    });
  }

  function renderPieces(root) {
    const wrap = root.querySelector('[data-cod-pieces]');
    if (!wrap) return;

    const options = getOptions(root);
    const pieces = getPieces(root);
    const soldOut = root.dataset.soldOutLabel || '';

    const rows = pieces.map((values, index) => {
      const fields = options.map((option, o) => {
        const choices = option.values
          .map((value) => {
            const test = values.slice();
            test[o] = value;
            const variant = findVariant(root, test);
            const off = !variant || variant.available === false;
            const attrs = (value === values[o] ? ' selected' : '') + (off && o > 0 && value !== values[o] ? ' disabled' : '');
            return `<option value="${escapeHtml(value)}"${attrs}>${escapeHtml(value)}${off ? ` (${escapeHtml(soldOut)})` : ''}</option>`;
          })
          .join('');
        return (
          '<label class="cod-piece__field">' +
          `<span>${escapeHtml(option.label || option.name)}</span>` +
          `<select data-cod-piece="${index}" data-cod-piece-option="${o}">${choices}</select>` +
          '</label>'
        );
      });
      const remove =
        index >= 3
          ? `<button type="button" class="cod-piece__remove" data-cod-remove-piece="${index}" aria-label="حذف">×</button>`
          : '';
      const label = (root.dataset.pieceLabel || '').replace('{n}', String(index + 1));
      return `<div class="cod-piece"><span class="cod-piece__label">${escapeHtml(label)}</span>${fields.join('')}${remove}</div>`;
    });

    const add =
      pieces.length >= 3
        ? `<button type="button" class="cod-piece__add" data-cod-add-piece>${escapeHtml(root.dataset.addPieceLabel || '')}</button>`
        : '';
    wrap.innerHTML = rows.join('') + add;

    // Keep the rows right under the selected card.
    const active = root.querySelector('.cod-offer.is-active');
    if (active && active.nextElementSibling !== wrap) active.after(wrap);
  }

  // Selects the piece's options in the theme's (hidden) pickers so the photos
  // follow the colour being chosen.
  function showPieceInGallery(root, values) {
    const pickers = getScope(root).querySelector('variant-radios, .product-variants-options-details');
    if (!pickers) return;
    getOptions(root).forEach((option, o) => {
      const input = Array.from(pickers.querySelectorAll('input[type="radio"]')).find(
        (el) => el.name === option.name && el.value === values[o],
      );
      if (input && !input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  // Picking an offer card sets how many pieces are ordered.
  function choosePack(root, pieces) {
    setPieceCount(root, pieces);
    updateSummary(root);
  }

  function updateSummary(root) {
    const lines = isPackMode(root) ? pieceLines(root) : getOrderLines(root);
    const pricing = packPricing(root, lines);
    // Free delivery follows the regular price, so a 3-pack keeps "3 pieces = free delivery".
    const ship = shippingFee(root, pricing.subtotal);
    const total = pricing.total + ship;

    const subEl = root.querySelector('[data-product-cod-subtotal]');
    const discountRow = root.querySelector('[data-cod-discount-row]');
    const discountEl = root.querySelector('[data-product-cod-discount]');
    const shipEl = root.querySelector('[data-product-cod-shipping]');
    const totalEl = root.querySelector('[data-product-cod-total]');
    const freeHint = root.querySelector('[data-cod-free-ship-hint]');

    if (subEl) subEl.textContent = formatMoney(pricing.subtotal);
    if (discountRow) discountRow.hidden = pricing.discount <= 0;
    if (discountEl) discountEl.textContent = `- ${formatMoney(pricing.discount)}`;
    if (shipEl) shipEl.textContent = ship === 0 ? 'مجاني' : formatMoney(ship);
    if (totalEl) totalEl.textContent = formatMoney(total);

    if (freeHint) {
      const min = Number(root.dataset.freeShippingMin) || 20000;
      const missing = min - pricing.subtotal;
      freeHint.hidden = missing <= 0;
      if (missing > 0) {
        freeHint.textContent = (root.dataset.freeShipHint || '').replace('{amount}', formatMoney(missing));
      }
    }

    renderLines(root, lines);
    renderPackOptions(root, pricing);
    if (isPackMode(root)) renderPieces(root);
  }

  function addCurrentLine(root) {
    const id = getVariantId(root);
    if (!id) return;
    const variant = getVariants(root).get(String(id));
    if (variant && variant.available === false) return;

    const lines = getSavedLines(root);
    const qty = getQuantity(root);
    const existing = lines.find((line) => line.id === String(id));
    if (existing) existing.qty += qty;
    else lines.push({ id: String(id), qty });

    setQuantity(root, 1);
    updateSummary(root);

    const hint = root.querySelector('[data-cod-lines-hint]');
    if (hint) hint.hidden = false;
    const pickers = getScope(root).querySelector('.product-variants-options-details, .color-swatches-box');
    pickers?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function removeLine(root, index) {
    const lines = getSavedLines(root);
    if (index < 0 || index >= lines.length) return;
    lines.splice(index, 1);
    updateSummary(root);
  }

  function buildCartPayload(root, lines) {
    const pricing = packPricing(root, lines);
    const items = discountedLines(lines, pricing).map((line) => ({
      variant_id: Number(line.id),
      quantity: line.qty,
      price: line.price,
      line_price: line.price * line.qty,
    }));
    return {
      items,
      item_count: items.reduce((sum, item) => sum + item.quantity, 0),
      total_price: items.reduce((sum, item) => sum + item.line_price, 0),
      original_total_price: pricing.subtotal,
      total_discount: pricing.discount,
    };
  }

  function clearCartInBackground() {
    const url = `${window.routes?.cart_url || '/cart'}/clear.js`;
    fetch(url, { method: 'POST', keepalive: true }).catch(() => {});
    if (typeof window.refreshHeaderCartCount === 'function') {
      window.refreshHeaderCartCount().catch(() => {});
    }
  }

  function redirectToConfirmation(root, orderName) {
    const base = root.dataset.confirmationUrl || '/pages/commande-confirmee';
    const params = new URLSearchParams();
    if (orderName) params.set('ref', orderName);
    if (root.dataset.productId) params.set('product_id', root.dataset.productId);
    window.location.href = `${base}?${params.toString()}`;
  }

  function setSubmitLoading(button, loading) {
    const label = button.querySelector('[data-product-cod-submit-text]');
    const loader = button.querySelector('.btn-loader');
    if (loading) {
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('loading');
      if (label) label.textContent = 'Création de votre commande…';
      loader?.classList.remove('hidden');
    } else {
      button.removeAttribute('aria-disabled');
      button.classList.remove('loading');
      if (label) label.textContent = 'Commander maintenant';
      loader?.classList.add('hidden');
    }
  }

  async function submitCodOrder(button) {
    const root = getRoot(button);
    const form = getForm(root);
    if (!root || !form) return;

    showGlobalError(form, '');
    if (!validateAll(form)) return;

    const fields = readFields(form);
    const phoneDigits = normalizeTunisiaPhone(fields.phone);
    fields.phone = formatTunisiaPhone(phoneDigits);
    if (!fields.email) fields.email = `client+${phoneDigits}@exceptiones.com`;

    if (isPackMode(root) && invalidPieces(root)) {
      showGlobalError(form, root.dataset.piecesError || 'تعذر العثور على هذا الخيار من المنتج.');
      root.querySelector('[data-cod-pieces]')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    const lines = isPackMode(root) ? pieceLines(root) : getOrderLines(root);
    if (!lines.length) {
      showGlobalError(form, 'تعذر العثور على هذا الخيار من المنتج.');
      return;
    }

    setSubmitLoading(button, true);

    let redirecting = false;

    try {
      const cart = buildCartPayload(root, lines);

      const res = await fetch(COD_API, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ fields, cart }),
      });

      const payload = await res.json().catch(() => ({}));

      if (!res.ok) {
        throw new Error(payload.error || 'تعذر إتمام الطلب حاليًا.');
      }

      redirecting = true;
      clearCartInBackground();
      redirectToConfirmation(root, payload.orderName);
    } catch (e) {
      console.error('[product-cod]', e);
      showGlobalError(
        form,
        e.message ||
          'الخدمة غير متوفرة حاليًا. حاول مجددًا أو تواصل معنا.',
      );
    } finally {
      if (!redirecting) setSubmitLoading(button, false);
    }
  }

  function bindFieldValidation(root) {
    const form = getForm(root);
    if (!form) return;

    form.querySelectorAll('[data-quick-order-field]').forEach((input) => {
      const fieldKey = input.dataset.quickOrderField;
      if (!fieldKey) return;

      const validateOne = () => {
        const fields = readFields(form);
        const message = validateField(fieldKey, fields);
        if (!message) {
          setFieldError(form, fieldKey, '');
          return;
        }
        if (fieldKey === 'email' && !fields.email) {
          setFieldError(form, fieldKey, '');
          return;
        }
        setFieldError(form, fieldKey, message);
      };

      input.addEventListener('blur', validateOne);
      input.addEventListener('input', () => {
        const wrap = form.querySelector(`[data-cod-field="${fieldKey}"]`);
        if (wrap?.classList.contains('product-cod-form__field--error')) {
          validateOne();
        }
      });
      input.addEventListener('change', validateOne);
    });
  }

  function bindPhoneInput(root) {
    const phone = root.querySelector('[data-quick-order-field="phone"]');
    if (!phone) return;

    const formatField = () => {
      const formatted = formatPhoneInput(phone.value);
      if (formatted !== phone.value) {
        phone.value = formatted;
        phone.setSelectionRange(formatted.length, formatted.length);
      }
    };

    phone.addEventListener('input', formatField);
    phone.addEventListener('blur', () => {
      const digits = normalizeTunisiaPhone(phone.value);
      phone.value = digits ? formatTunisiaPhone(digits) : formatPhoneInput(phone.value);
    });
  }

  function bindCheckout(root) {
    if (isPackMode(root)) getScope(root).classList.add('cod-pack-mode');
    updateSummary(root);
    bindPhoneInput(root);
    bindFieldValidation(root);
  }

  function allRoots() {
    return document.querySelectorAll('[data-product-cod-checkout]');
  }

  // Quantity changes happen outside the COD block, so listen on the document.
  function onQuantityChange(event) {
    if (!(event.target instanceof Element) || !event.target.matches(QTY_SELECTOR)) return;
    allRoots().forEach(updateSummary);
  }

  document.addEventListener('change', onQuantityChange);
  document.addEventListener('input', onQuantityChange);

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    // The theme's +/- buttons may set the value without firing an event.
    if (event.target.closest('[data-increment-quantity], [data-decrement-quantity]')) {
      setTimeout(() => allRoots().forEach(updateSummary), 0);
      return;
    }

    const packOption = event.target.closest('[data-cod-pack-option]');
    if (packOption) {
      event.preventDefault();
      choosePack(getRoot(packOption), Number(packOption.dataset.codPackOption));
      return;
    }

    const addPiece = event.target.closest('[data-cod-add-piece]');
    if (addPiece) {
      event.preventDefault();
      const root = getRoot(addPiece);
      setPieceCount(root, getPieces(root).length + 1);
      updateSummary(root);
      return;
    }

    const removePiece = event.target.closest('[data-cod-remove-piece]');
    if (removePiece) {
      event.preventDefault();
      const root = getRoot(removePiece);
      getPieces(root).splice(Number(removePiece.dataset.codRemovePiece), 1);
      updateSummary(root);
      return;
    }

    const addButton = event.target.closest('[data-cod-add-line]');
    if (addButton) {
      event.preventDefault();
      addCurrentLine(getRoot(addButton));
      return;
    }

    const removeButton = event.target.closest('[data-cod-remove-line]');
    if (removeButton) {
      event.preventDefault();
      removeLine(getRoot(removeButton), Number(removeButton.dataset.codRemoveLine));
      return;
    }

    const button = event.target.closest('[data-product-cod-submit]');
    if (!button || button.getAttribute('aria-disabled') === 'true') return;
    event.preventDefault();
    submitCodOrder(button);
  });

  document.addEventListener('DOMContentLoaded', () => {
    allRoots().forEach(bindCheckout);
  });

  document.addEventListener('change', (event) => {
    const select = event.target;
    if (!(select instanceof HTMLSelectElement) || !select.matches('[data-cod-piece]')) return;
    const root = getRoot(select);
    const values = getPieces(root)[Number(select.dataset.codPiece)];
    if (!values) return;
    values[Number(select.dataset.codPieceOption)] = select.value;
    updateSummary(root);
    showPieceInGallery(root, values);
  });

  document.addEventListener('change', async (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || input.name !== 'id') return;
    const root = input.closest('[data-product-cod-checkout]');
    if (!root || !input.value) return;

    const known = getVariants(root).get(String(input.value));
    if (known) {
      root.dataset.variantPrice = String(known.price);
      updateSummary(root);
      return;
    }

    try {
      const res = await fetch(`/variants/${input.value}.js`);
      const variant = await res.json();
      root.dataset.variantPrice = String(variant.price);
      updateSummary(root);
    } catch (e) {
      console.warn('product-cod variant', e);
    }
  });
})();
